import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { IDisableAccelerationAction } from '../../ts/ServerApi/types/actionNames';
import { IWorkbookInfo } from '../../ts/models/IWorkbookInfo';
import { Action } from 'redux';
import { DisableWorkbookAcceleration } from '../../app/actions/AppActionTypes';
import { IEntityAction, EntityActionNames } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { WorkbookAccelerationActions } from './WorkbookAccelerationActions';

export const DisableWorkbookAccelerationEntityAction: IEntityAction<IWorkbookInfo, IDisableAccelerationAction> = {
  name: EntityActionNames.DisableWorkbookAcceleration,
  translateName: Messages.disableAcceleration,
  isVisible: (targetItems: IWorkbookInfo[]) => {
    return WorkbookAccelerationActions.assurePermission(targetItems);
  },
  isClickable: (availableActions: IDisableAccelerationAction, targetItems: IWorkbookInfo[]) => {
    return WorkbookAccelerationActions.assurePermission(targetItems) &&
              (targetItems.length > 1 ||
                !!(availableActions && availableActions.disableAcceleration));
  },
  createReduxAction: (targetItems: IWorkbookInfo[]) => disableWorkbookAcceleration(targetItems)
};

export interface DisableWorkbookAccelerationAction extends Action {
  selectedContent: IWorkbookInfo[];
}

export function disableWorkbookAcceleration(
  selectedContent: IWorkbookInfo[]
): DisableWorkbookAccelerationAction {
  return {
    type: DisableWorkbookAcceleration,
    selectedContent: selectedContent,
  };
}
